/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */
import { Pause, Play } from 'lucide-react';
import { FC, memo } from 'react';

import Btn from './Btn';

interface PlaybackProps {
    isPlaying: boolean;
    onToggle: () => void;
}

const Playback: FC<PlaybackProps> = ({ isPlaying, onToggle }) => (
    <Btn label={isPlaying ? 'Pause' : 'Play'} onClick={onToggle}>
        {isPlaying ? <Pause /> : <Play />}
    </Btn>
);

export default memo(Playback);
